<ng-container *ngIf="isLoaded && isActive">
  <div class="container">
    <div class="header-title-container">
      <p><adp-label labelKey="Account_TechSupport_History_Title"></adp-label></p>
    </div>
    <div class="mt-20 mb-20">
      <div class="mt-20 pb-4 header-desc">
        <adp-label labelKey="Account_TechSupport_History_Text"></adp-label>
      </div>
    </div>
  </div>
  <router-outlet></router-outlet>
</ng-container>
